var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.926758 6.99975C0.926758 6.80775 1.00852 6.61575 1.17261 6.46925L7.33242 0.96975C7.66004 0.67675 8.19207 0.67675 8.52025 0.96975L14.6806 6.46925C15.0088 6.76225 15.0088 7.23675 14.6806 7.52975C14.353 7.82275 13.821 7.82275 13.4928 7.52975L7.92662 2.56075L2.361 7.52975C2.03283 7.82275 1.50135 7.82275 1.17317 7.52975C1.00852 7.38375 0.926758 7.19175 0.926758 6.99975V6.99975Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.6be8dac207e2193cc18c6b8cf12e4690.svg";
export { ForwardRef as ReactComponent };